
import Vue from 'vue';
import { Data as HeadlinesData, DataWithHref } from '@root/modules/headlines/types/headlines';
import UniversalHeadlinesService from '@root/modules/headlines/services/UniversalHeadlines.service';
import getHeadlineWithHref from '@root/modules/headlines/utils/getHeadlineWithHref';
import HeadlineBlocks from '@root/common/components/base/headline/HeadlineBlocks.vue';

interface Methods {
  getHeadline: (headline: HeadlinesData) => DataWithHref;
  getTopHeadlines: () => void;
}
interface Computed {
  isSidebarOpen: boolean;
  activeArticleCategoryId: number | undefined;
  headlines: HeadlinesData[];
}

interface Data {
  data: Record<string, any>;
  domain: string;
  limit: number;
  settings: Record<string, any>;
}

export default Vue.extend<Data, Methods, Computed, unknown>({
  components: {
    HeadlineBlocks,
  },
  data() {
    const { domain } = this.$channelConfig('settings');
    return {
      data: {
        items: [],
      },
      domain,
      limit: 50,
      settings: {
        channel: false,
        category: false,
        lead: false,
        publishDate: false,
        author: false,
        titleComment: true,
      },
    };
  },
  computed: {
    isSidebarOpen() {
      return this.$store.getters['navigation/getHeaderAction']('sidebar');
    },
    activeArticleCategoryId() {
      return this.$store.getters['article/getActiveArticle']?.primaryCategory.id;
    },
    headlines() {
      const headlines = this.$store.getters['article/getMultimedijaArticles'];

      return headlines && headlines.items ? headlines.items.map((headline: HeadlinesData) => this.getHeadline(headline)) : [];
    },
  },
  watch: {
    activeArticleCategoryId: {
      handler: function (newValue, oldValue) {
        if (newValue !== null && typeof newValue !== 'undefined') {
          if (this.isSidebarOpen) {
            this.$store.commit('navigation/setHeaderAction', { type: 'sidebar', value: false });
          }
          if (newValue !== oldValue && typeof oldValue !== 'undefined') {
            this.getTopHeadlines();
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    getHeadline(headline) {
      const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;
      return getHeadlineWithHref({ headline, domain: this.domain, fakeDomainEnabled });
    },
    async getTopHeadlines() {
      const universalHeadlinesService = new UniversalHeadlinesService();
      const headlines = await universalHeadlinesService.fetch({
        domain: this.domain,
        categoryId: this.activeArticleCategoryId,
        getCount: true,
        limit: this.limit,
      });
      this.$store.commit('article/setMultimedijaArticles', headlines);
    },
  },
});
